import { Gym } from 'fitbeat.models';
import {
  AreaCategory,
  getAreaCategory,
  isStaticZone,
  ZoneMappings,
} from '../../config/zone-mappings';

export enum Side {
  Left = 'Left',
  Right = 'Right',
}

export class Zone {
  // TODO: make this part of zone names
  public static boxingZones = [7, 8, 13, 14, 17];

  public static isBoxingZone(zoneNumber: number) {
    return Zone.boxingZones.findIndex((zn: number) => zoneNumber === zn) >= 0;
  }

  // zones is just odd/even station pairs
  // station numbers are 0 based, zone numbers are 1 based
  // numberInGym is based on the station numbers (0,1 on zone 1, 2,3 on zone 2, ... 39 is on zone 20)
  // the zone type is based on the mapping for the zones in the gym
  public static zoneForStation(stationNumber: number, gym: Gym): Zone {
    const numberInGym = Math.floor(stationNumber / 2) + 1;
    // todo: see if we can remove type number from zone
    const typeNumber = ZoneMappings.getZoneTypesForNumberInGym(numberInGym, gym)[0];
    const isStaticZoneType = isStaticZone(typeNumber);
    const areaCategory = getAreaCategory(typeNumber);
    // note: this assumes that zoneMapping defines circuit zones before any static zones
    const numberOfCircuitZones = gym.zoneMapping
      .filter((zoneTypes: number[]) => !isStaticZone(zoneTypes[0]))
      .length;

    function calculateNextZoneNumber() {
      if (isStaticZoneType) {
        // static zone's dont move, next is the same as current
        return numberInGym;
      }

      const isLastCircuitZone = numberOfCircuitZones === numberInGym;
      return isLastCircuitZone ? 1 : numberInGym + 1;
    }

    function getDisplayNumber(): string {
      if (isStaticZoneType) {
        const staticZoneNumber = numberInGym - numberOfCircuitZones;
        return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[staticZoneNumber - 1];
      }

      return numberInGym.toString();
    }

    return {
      typeNumber,
      numberInGym,
      side: Zone.stationSide(stationNumber),
      name: ZoneMappings.getZoneName(typeNumber),
      nextZoneNumber: calculateNextZoneNumber(),
      displayNumber: getDisplayNumber(),
      areaCategory,
    };
  }

  public static stationSide(stationNumber: number): Side {
    return stationNumber % 2 ? Side.Right : Side.Left;
  }

  public static firstStationForZoneNumber(zoneNumber: number): number {
    return (zoneNumber - 1) * 2;
  }

  public typeNumber: number;

  public displayNumber: string;

  public areaCategory: AreaCategory;

  public numberInGym: number;

  public side: Side;

  public name: string;

  public nextZoneNumber: number;
}

export interface IZoneMapping {
  ip: string;
  zoneNumber: string;
}
